import axios from 'axios'
import { CATALOGO_ENDPOINT } from 'common/endpoints'

export const sendCatalogMail = async (id, email, name) => {
    const response = await axios(
        `${CATALOGO_ENDPOINT}/${id}/mail?email=${email}&name=${name}`
    )
    return response;
}
